import { useQuery } from "@tanstack/react-query";
import { UTILITY_KIND } from "../../models/Utility";
import type { UseUtilityConsumptionInput } from "../models/UtilityConsumption";
import { getUtilityConsumption } from "../repositories/ConsumptionRepository";

const QUERY_ROOT = "utility-consumption";
const ALL_METERS_KEY = "all";

export const useUtilityConsumption = ({
	targetId,
	enabled: viewEnabled,
	utility,
	externalMeterIds,
	mode,
	period,
	waitForEveryMeter = true,
}: UseUtilityConsumptionInput) => {
	const canonicalMeterIds =
		externalMeterIds === null
			? null
			: [...new Set(externalMeterIds)].sort((left, right) =>
					left.localeCompare(right),
				);
	const meterQueryKey = canonicalMeterIds?.join("|") ?? ALL_METERS_KEY;
	const startIso = period.startUtc.toISOString();
	const endIso = period.endUtc.toISOString();
	const enabled = viewEnabled && utility === UTILITY_KIND.WATER;
	return useQuery({
		queryKey: [
			QUERY_ROOT,
			targetId,
			meterQueryKey,
			mode,
			startIso,
			endIso,
			waitForEveryMeter,
		],
		queryFn: ({ signal }) =>
			getUtilityConsumption(
				{
					targetId,
					externalMeterIds: canonicalMeterIds,
					mode,
					startUtc: period.startUtc,
					endUtc: period.endUtc,
					waitForEveryMeter,
				},
				signal,
			),
		enabled,
		keepPreviousData: true,
		refetchInterval: 60_000,
		refetchOnWindowFocus: true,
		retry: 1,
	});
};
